export function getImageByArticleType(articleType: string): string {
	switch (articleType) {
		case 'MARVEL_RIVALS':
			return '/assets/icons/Marvel_Rivals_logo.svg';
		case 'OVERWATCH':
			return '/assets/images/max_button/max_button_overwatch.png';
		case 'TEAM_PEPS':
			return '/assets/images/team_peps_logo.avif';
		case 'POKEMON_UNITE':
			return '/assets/images/team_peps_pokemon.png';
		case 'POKEMON_VGC':
			return '/assets/images/team_peps_pokemon.png';
		default:
			return '/assets/images/team_peps_logo.avif';
	}
}
